import { request } from "../../utils/config"

export interface AllowedModule {
  id: number
  code: string
  name: string
  path: string
}

export interface MeResponse {
  userId: number
  userName: string
  managerId: number | null
  roleId: number
  isSuperAdmin: boolean
  /**
   * Tizimning EGASI. Korxona admini ham super-admin ko'rinadi — o'z
   * korxonasida u haqiqatan xo'jayin. Lekin korxonalar ro'yxati, obuna
   * narxi va kalit chiqarish faqat egasiga tegishli.
   */
  isPlatformOwner: boolean
  /** Qaysi korxonaga tegishli. null — platforma hisobi. */
  tenantId: number | null
  /** AI yordamchisi shu foydalanuvchida ko'rinadimi (adminni sozlamasi) */
  aiEnabled: boolean
  allowedModules: AllowedModule[]
}

export const ALLOWED_MODULES_KEY = "allowed_modules"
export const IS_SUPER_ADMIN_KEY = "is_super_admin"
export const IS_PLATFORM_OWNER_KEY = "is_platform_owner"
export const AI_ENABLED_KEY = "ai_enabled"
export const PERMISSIONS_UPDATED_EVENT = "permissions_updated"

/**
 * Joriy foydalanuvchining bo'limlarga ruxsatlarini backenddan qayta oladi.
 * Login javobidagi ruxsatlar faqat kirish paytida olingani uchun admin
 * ruxsatni o'zgartirsa, xodim qayta kirmaguncha eski holat qolib ketardi.
 */
export const GET_ME = async (): Promise<MeResponse> => {
  const response = await request({
    url: `AccountAPI/Me`,
    method: "GET",
    silent: true,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  const d = response.data || {}
  const modules = d.allowedModules || d.AllowedModules || []
  return {
    userId: d.userId ?? d.UserId,
    userName: d.userName ?? d.UserName,
    managerId: d.managerId ?? d.ManagerId ?? null,
    roleId: d.roleId ?? d.RoleId,
    isSuperAdmin: !!(d.isSuperAdmin ?? d.IsSuperAdmin),
    // Eski backend bu maydonni qaytarmasa — YO'Q deb hisoblanadi.
    // Bu ataylab teskari: platforma sahifasi ko'rinib qolgandan ko'ra
    // ko'rinmay turgani xavfsiz.
    isPlatformOwner: !!(d.isPlatformOwner ?? d.IsPlatformOwner),
    tenantId: d.tenantId ?? d.TenantId ?? null,
    // Eski backend bu maydonni qaytarmasa yoqilgan deb hisoblanadi —
    // deploy oralig'ida AI to'satdan yo'qolib qolmasligi uchun
    aiEnabled: (d.aiEnabled ?? d.AiEnabled) !== false,
    allowedModules: modules.map((m: any) => ({
      id: m.id ?? m.Id,
      code: m.code ?? m.Code,
      name: m.name ?? m.Name,
      path: m.path ?? m.Path,
    })),
  }
}

/**
 * Ruxsatlarni yangilab, localStorage ga saqlaydi va menyuni qayta chizdiradi.
 * So'rov muvaffaqiyatsiz bo'lsa eski holat saqlanib qoladi — xodim
 * tasodifan tizimdan qulflanib qolmasligi uchun.
 */
export const refreshPermissions = async (): Promise<void> => {
  try {
    const me = await GET_ME()
    localStorage.setItem(IS_SUPER_ADMIN_KEY, me.isSuperAdmin ? "1" : "0")
    localStorage.setItem(IS_PLATFORM_OWNER_KEY, me.isPlatformOwner ? "1" : "0")
    localStorage.setItem(AI_ENABLED_KEY, me.aiEnabled ? "1" : "0")
    localStorage.setItem(
      ALLOWED_MODULES_KEY,
      JSON.stringify(me.allowedModules.map((m) => m.code).filter(Boolean))
    )
    window.dispatchEvent(new Event(PERMISSIONS_UPDATED_EVENT))
  } catch {
    // jim: eski ruxsatlar bilan ishlashda davom etamiz
  }
}
